import { apiCall } from './gqlClient';

const WORKOUTS_QUERY = `
  query workouts($providerId: Float) {
    workouts(providerId: $providerId)
    {
      id
			providerId
			title
			description
			instructions
			imageId
			dateCreated
			active
			level
			price
			archive
			isPublic
			sourceId
			ownerId
			isPlatformDefault
      ...fragments
    }
  }`;

export const workoutsApiCall = async ({providerId}, fragments = null) => apiCall({ query: WORKOUTS_QUERY, variables: {providerId}, fragments });

const LIBRARYCOVERS_QUERY = `
  query libraryCovers($workoutIds: JSON, $circuitIds: JSON) {
    libraryCovers(workoutIds: $workoutIds, circuitIds: $circuitIds)
    {
      id
			kind
			coverUrl
      ...fragments
    }
  }`;

export const libraryCoversApiCall = async ({workoutIds, circuitIds}, fragments = null) => apiCall({ query: LIBRARYCOVERS_QUERY, variables: {workoutIds, circuitIds}, fragments });

const WORKOUT_QUERY = `
  query workout($id: String!) {
    workout(id: $id)
    {
      id
			providerId
			title
			description
			instructions
			imageId
			dateCreated
			active
			level
			price
			archive
			isPublic
			sourceId
			ownerId
			isPlatformDefault
      ...fragments
    }
  }`;

export const workoutApiCall = async ({id}, fragments = null) => apiCall({ query: WORKOUT_QUERY, variables: {id}, fragments });

const CREATEWORKOUT_QUERY = `
  mutation createWorkout($input: WorkoutInput!) {
    createWorkout(input: $input)
    {
      id
			providerId
			title
			description
			instructions
			imageId
			dateCreated
			active
			level
			price
			archive
			isPublic
			sourceId
			ownerId
			isPlatformDefault
      ...fragments
    }
  }`;

export const createWorkoutApiCall = async ({input}, fragments = null) => apiCall({ query: CREATEWORKOUT_QUERY, variables: {input}, fragments });

const UPDATEWORKOUT_QUERY = `
  mutation updateWorkout($id: String!, $input: WorkoutInput!) {
    updateWorkout(id: $id, input: $input)
    {
      id
			providerId
			title
			description
			instructions
			imageId
			dateCreated
			active
			level
			price
			archive
			isPublic
			sourceId
			ownerId
			isPlatformDefault
      ...fragments
    }
  }`;

export const updateWorkoutApiCall = async ({id, input}, fragments = null) => apiCall({ query: UPDATEWORKOUT_QUERY, variables: {id, input}, fragments });

const DELETEWORKOUT_QUERY = `
  mutation deleteWorkout($id: String!) {
    deleteWorkout(id: $id)
    {
      id
			providerId
			title
			description
			instructions
			imageId
			dateCreated
			active
			level
			price
			archive
			isPublic
			sourceId
			ownerId
			isPlatformDefault
      ...fragments
    }
  }`;

export const deleteWorkoutApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEWORKOUT_QUERY, variables: {id}, fragments });
